export const menuOnClick = (setContextMenu, onClickFn) => {
  if (typeof onClickFn === "function") {
    onClickFn();
  } else {
    console.error("menuOnClick was not supplied a properly formed function");
  }
  setContextMenu(null);
};
